import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import QRCode, { MockQRCode } from "./QRCode/QRCode";
import Button from "../../../components/UI/Button/Button";
import Card from "../../../components/UI/Card/Card";
import Helper from "../../../lib/Helper";

import PhotoReader from "../PhotoReader/PhotoReader";

import { qrcodeActions } from "../../store/qr-code";
import { qrImageActions } from "../../store/qr-image";


const CodeReader = ({ onValidChange, ...props }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [image, setImage] = useState(null);
  const [readStatic, setReadStatic] = useState(false);

  useEffect(() => { onValidChange(!!image); }, [image]);

  const changeDataHandler = async (data) => {
    setData( data );
    dispatch( qrcodeActions.store(data) );
  };

  const photoTakenHandler = async (img) => {
    dispatch( qrImageActions.store(img) );
    setImage( img );
    setReadStatic( false );
  };

  const toggleReadStatic = () => {
    setReadStatic( !readStatic );
  }

  return (
    <>
      {data && (
        <>
          <Button onClick={() => setData(null)}>Erneut einlesen</Button>
          <br />
          <Card>
            <h3>QR Code erkannt</h3>
            Ausgestellt am {Helper.PrintDate(data.created)}&nbsp; von{" "}
            {data.createdBy}&nbsp; ({data.submittedBy}).
            {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
          </Card>
        </>
      )}
      { image && (
        <>
          <Card>
            <img src={image} width="100px" />
          </Card>
          <br />
          <Button onClick={() => {setImage(null); setReadStatic(true);}}>Erneut einlesen</Button>
        </>
      )}
      { !data && !image && (
        <>
          <div style={{ margin: "20px", lineHeight: "130%" }}>
            <p>
              Der genetische Befund Ihres Labors enthält einen QR-Code für
              FindMe2care, in dem Ihre individuellen Diagnosedaten verschlüsselt
              sind.
            </p>
            <p>
              Halten Sie jetzt den QR-Code Ihres genetischen Befundes vor die
              Kamera Ihres Handys oder Computers. Benutzen Sie bei Handys oder
              Tablets die rückwärtige Kamera. Halten Sie das Blatt möglichst
              gerade und stellen Sie sicher, dass der QR-Code innerhalb der
              Markierungen im Sucher des Kamerafelds liegt und diesen Bereich
              möglichst ausfüllt.
            </p>
            { readStatic
              ? "Hier kehren Sie zum QR-Code Reader zurück:"
              : "Sollten Sie Probleme beim Scannen des QR-Codes haben, versuchen Sie es hier:"
            }
            <p>
              <Button onClick={toggleReadStatic}>{readStatic ? 'QR-Reader' : 'Foto einreichen'}</Button>
            </p>
            <p>
              { readStatic && "Sollten Sie auch hier Probleme beim Scannen des QR-Codes haben, schreiben Sie bitte eine E-Mail an info@findme2care.de. Bitte geben Sie uns Ihre bevorzugten Kontaktdaten (Telefonnummer oder E-Mail) an. Wir unterstützen Sie baldmöglichst."}
            </p>
          </div>
          { readStatic 
            ? <PhotoReader onCancel={toggleReadStatic} 
                           onTrigger={photoTakenHandler} />
            : <QRCode onSetData={changeDataHandler} />
          }
        </>
      )}
    </>
  );
};

export default CodeReader;
